import { produce } from 'immer';
import {
  SET_TOKEN_DETAILS,
  SET_LOGGED_OUT,
  SET_SELECTED_ACCESS_GROUP,
  RESET_SELECTED_ACCESS_GROUP,
  SET_AUTHORIZATION_FAILURE,
  SET_ACCESS_GROUP_LIST,
  SET_IS_FIRSTVISIT,
  SET_PERMISSION_LEVEL,
  REGISTER_TEAM,
} from '../actions/userInfoActionTypes';
import { IS_FIRST_VISIT } from '../constants/createSegment';
import { ResponseStatus } from '../enums/responseStatus';

const initialState = {
  idToken: '',
  idTokenDecoded: '',
  accessToken: '',
  accessTokenDecoded: '',
  refreshToken: '',
  user: '',
  userEmail: '',
  accessGroupName: '',
  isLoggedOut: '',
  isAuthorizationFailure: false,
  accessGroupsList: [],
  selectedAccessGroupName: 'testLdapGroupName2',
  isFirstVisit: true,
  isAdmin: false,
  permissionLevel: '',
  status: ResponseStatus.PENDING,
  registerTeam: {
    status: '',
    registered: null,
  },
};

export default function userInfo(state = initialState, action) {
  return produce(state, draftState => {
    switch (action.type) {
      /**
       * Set tokens received from Federate / Cognito login
       */
      case SET_TOKEN_DETAILS: {
        const {
          idToken,
          accessToken,
          idTokenDecoded,
          accessTokenDecoded,
          refreshToken,
        } = action.payload;

        if (
          'identities' in idTokenDecoded &&
          Array.isArray(idTokenDecoded.identities) &&
          idTokenDecoded.identities.length > 0
        ) {
          draftState.user = idTokenDecoded.identities[0].userId;
        } else if ('email' in idTokenDecoded) {
          draftState.user = idTokenDecoded.email.replace('@amazon.com', '');
        }

        draftState.idToken = idToken;
        draftState.idTokenDecoded = idTokenDecoded;
        draftState.accessToken = accessToken;
        draftState.accessTokenDecoded = accessTokenDecoded;
        draftState.refreshToken = refreshToken;
        draftState.userEmail = idTokenDecoded.email;
        break;
      }

      case SET_LOGGED_OUT: {
        draftState.isLoggedOut = action.payload;
        draftState.user = '';
        break;
      }

      case SET_SELECTED_ACCESS_GROUP: {
        const { accessGroupName } = action.payload;
        draftState.selectedAccessGroupName = accessGroupName;
        break;
      }

      case RESET_SELECTED_ACCESS_GROUP: {
        draftState.accessGroupName = '';
        break;
      }

      case SET_AUTHORIZATION_FAILURE: {
        draftState.isAuthorizationFailure = action.payload;
        break;
      }

      case SET_ACCESS_GROUP_LIST: {
        draftState.accessGroupsList = action.payload;
        break;
      }

      case SET_IS_FIRSTVISIT: {
        draftState.isFirstVisit = action.payload;
        localStorage.setItem(IS_FIRST_VISIT, 'true');
        break;
      }

      case SET_PERMISSION_LEVEL: {
        draftState.isAdmin = action.payload?.data?.isAdmin;
        draftState.permissionLevel = action.payload?.data?.permissionLevel;
        draftState.status = action.payload?.status;
        break;
      }

      case REGISTER_TEAM: {
        draftState.registerTeam = action.payload;
        break;
      }

      default: {
        break;
      }
    }
  });
}
